// AI秘書モジュールの設定。Gateway URL とエンタイトルメント（課金でON）を環境変数から解決する。
// 将来は company_profile.entitlements.aiSecretary へ移す（現状はPoCのため環境変数）。

const RAW_URL = import.meta.env.VITE_AI_GATEWAY_URL ?? '';

/** Gateway のベースURL（末尾スラッシュ除去）。未設定なら空文字。 */
export const GATEWAY_URL = RAW_URL.replace(/\/+$/, '');

/** 課金でONの付加サービス。URL未設定 or フラグ未設定なら無効（＝ウィジェット非表示）。 */
export const IS_ENABLED =
  import.meta.env.VITE_AI_SECRETARY_ENABLED === 'true' && GATEWAY_URL !== '';

/**
 * 書込ツール（describe/create/update_record）の有効化。既定 false。
 * OFF のときは書込ツールが registry に登録されず、systemPrompt も閲覧専用宣言のまま
 * （＝LLMからは書込が物理的に存在しない）。docs/AI_SECRETARY_TOOL_ARCHITECTURE.md §7
 */
export const WRITE_ENABLED =
  IS_ENABLED && import.meta.env.VITE_AI_SECRETARY_WRITE_ENABLED === 'true';

/** 死活監視のポーリング間隔（ミリ秒）。睡眠↔覚醒の切替判定に使う。 */
export const HEALTH_POLL_MS = 20000;
